// extracted by mini-css-extract-plugin
export default {"products":"ju-z","card":"ku-z","oosMessaging":"lu-z"};